import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-global-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">
                亚洲一区
              </span>
            </Link>
            <p className="text-background-400 text-sm leading-relaxed">
              亚洲一区是您探索亚洲优质内容的首选平台，汇聚独家精选资源，覆盖多元文化、娱乐、资讯与生活方式。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">内容分类</h4>
            <div className="flex flex-col gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-background-400 hover:text-background-100 text-sm transition-colors whitespace-nowrap cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">快捷链接</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-background-400 hover:text-background-100 text-sm transition-colors whitespace-nowrap cursor-pointer">首页</Link>
              <Link to="/about" className="text-background-400 hover:text-background-100 text-sm transition-colors whitespace-nowrap cursor-pointer">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <div className="flex flex-col gap-2 text-background-400 text-sm">
              <p>邮箱：contact@yazhouyiqu.com</p>
              <p>工作时间：周一至周五 9:00-18:00</p>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background-500 text-xs">
            &copy; {new Date().getFullYear()} 亚洲一区 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-500 hover:text-background-200 text-sm transition-colors whitespace-nowrap cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="text-background-500 hover:text-background-200 text-sm transition-colors whitespace-nowrap cursor-pointer" rel="nofollow">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}